export const numberHotKeys = '1, 2, 3, 4, 5, 6, 7, 8, 9, 0'
export const alphabetHotKeys = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z'
export const universalHotKeys = 'Enter'
export const signHotKeys = ";,/,,,.,',],[,=,-,`"
export const specialHotKeys =
    "Shift+1,Shift+2,Shift+3,Shift+4,Shift+5,Shift+6,Shift+7,Shift+8,Shift+9,Shift+0,Shift+-,Shift+=,Shift+[,Shift+],Shift+;,Shift+',Shift+,,Shift+.,Shift+/"
